import styled from 'styled-components';

export const DashboardStyle = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .jumbotron {
    display: flex;
    justify-content: center;
    h3 {
      font-size: 2rem;
    }
    .container {
      line-height: 2.5;
    }
  }

  .section {
    display: flex;
    flex-direction: column;
    button:focus,
    button:active {
      outline: none;
      box-shadow: none;
    }
    button {
      align-self: flex-end;
    }

    .card-group {
      justify-content: space-around;
      a {
        margin: 10px;
      }
    }
  }
`;

export const Footer = styled.footer`
  align-self: flex-end;
  width: 100%;
  background-color: #343a40;
  padding: 1.5rem;
  color: #fff;
  margin-top: 1rem;
`;

export const Loaders = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 500px;
`;
